import { isValidElement } from 'react';
import { isArrayLike } from 'mobx';
import isNil from 'lodash/isNil';
import isBoolean from 'lodash/isBoolean';
import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';
export const suffixCls = 'modal';
export function normalizeProps(props) {
    if (isString(props) ||
        isValidElement(props) ||
        isBoolean(props) ||
        isNil(props) ||
        isNumber(props) ||
        isArrayLike(props)) {
        return {
            children: props,
        };
    }
    return props;
}
